import React, { useEffect, useState } from 'react';
import { APP_CONFIG } from '../../config/appConfig';
import DashStatTile from './DashStatTile';
import BlockchainBreakdownChart from './BlockchainBreakdownChart';
import LatestFindCard from './LatestFindCard';
import RecentFindsList from './RecentFindsList';
import { formatUSD, formatCompactNumber } from './dashboardFormat';
import './DashboardStats.css';

const BASE_URL = APP_CONFIG.API_BASE_URL;

const DashboardStats = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchStats = async () => {
      try {
        const res = await fetch(`${BASE_URL}/dashboard/stats`, {
          method: 'GET',
          credentials: 'include',
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || 'Failed to load stats');
        if (!cancelled) setData(json);
      } catch (err) {
        console.error('Error fetching dashboard stats:', err);
        if (!cancelled) setError('Could not load your stats right now.');
      }
    };

    fetchStats();
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div className="dash-stats-section">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="dash-stats-section">
        <div className="dash-kpi-row">
          <div className="dash-stat-tile dash-stat-tile-loading" />
          <div className="dash-stat-tile dash-stat-tile-loading" />
        </div>
      </div>
    );
  }

  const { lastWallet, stats, recentFinds } = data;

  return (
    <div className="dash-stats-section">
      <div className="dash-kpi-row">
        <DashStatTile label="Total money found" value={formatUSD(stats.totalMoneyFound)} />
        <DashStatTile label="Wallets searched" value={formatCompactNumber(stats.walletsSearched)} />
      </div>

      <div className="dash-stats-grid">
        <div className="dash-chart-card">
          <span className="dash-chart-card-title">Money Found by Blockchain</span>
          <BlockchainBreakdownChart perBlockchain={stats.perBlockchain} />
        </div>
        <LatestFindCard lastWallet={lastWallet} />
      </div>

      <RecentFindsList finds={recentFinds} />
    </div>
  );
};

export default DashboardStats;
